export const functionChoices = [
  'Accounting',
  'Administrative',
  'Arts and Design',
  'Business Development',
  'Community and Social Services',
  'Consulting',
  'Education',
  'Engineering',
  'Entrepreneurship',
  'Finance',
  'Healthcare Services',
  'Information Technology',
  'Legal',
  'Marketing',
  'Media and Communication',
  'Military and Protective Services',
  'Operations',
  'Product Management',
  'Program and Project Management',
  'Purchasing',
  'Quality Assurance',
  'Real Estate',
  'Research',
  'Sales',
  'Customer Success and Support',
];

export const eeoGenderChoices = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'Decline to self-identify', value: 'decline_to_self_identify' },
];

export const eeoRaceChoices = [
  { label: 'Hispanic or Latino', value: 'hispanic_or_latino' },
  { label: 'White (Not Hispanic or Latino)', value: 'white_not_hispanic_or_latino' },
  {
    label: 'Black or African American (Not Hispanic or Latino)',
    value: 'black_or_african_american_not_hispanic_or_latino',
  },
  {
    label: 'Native Hawaiian or Other Pacific Islander (Not Hispanic or Latino)',
    value: 'native_hawaiian_or_other_pacific_islander_not_hispanic_or_latino',
  },
  { label: 'Asian (Not Hispanic or Latino)', value: 'asian_not_hispanic_or_latino' },
  {
    label: 'American Indian or Alaska Native (Not Hispanic or Latino)',
    value: 'american_indian_or_alaska_native_not_hispanic_or_latino',
  },
  { label: 'Two or More Races (Not Hispanic or Latino)', value: 'two_or_more_races_not_hispanic_or_latino' },
  { label: 'Decline to self-identify', value: 'decline_to_self_identify' },
];

export const eeoVeteranStatusChoices = [
  { label: 'I am a veteran', value: 'veteran' },
  { label: 'I am not a veteran', value: 'not_veteran' },
  { label: 'Decline to self-identify', value: 'decline_to_self_identify' },
];

export const locationTypeOptions = [
  { label: 'On-site', value: 'OnSite' },
  { label: 'Hybrid', value: 'Hybrid' },
  { label: 'Remote', value: 'Remote' },
] as const;

export const jobTypeOptions = [
  { label: 'Permanent', value: 'Permanent' },
  { label: 'Contract', value: 'Contract' },
  { label: 'Full-time', value: 'FullTime' },
  { label: 'Part-time', value: 'PartTime' },
  { label: 'Temporary', value: 'Temporary' },
  { label: 'Custom', value: 'Custom' },
] as const;

export const getEEOLabel = (type: 'gender' | 'race' | 'veteran_status', value: string) => {
  switch (type) {
    case 'gender':
      return eeoGenderChoices.find(choice => choice.value === value)?.label;
    case 'race':
      return eeoRaceChoices.find(choice => choice.value === value)?.label;
    case 'veteran_status':
      return eeoVeteranStatusChoices.find(choice => choice.value === value)?.label;
  }
};
